import $ from "jquery";

class Menu {
    run() {
        this.menuOpen();
    }
    menuOpen(){
        $( "#menuToggler" ).on('click', function() {
            console.log('click')
            $('#menuToggler').toggleClass('close-menu');
            $('.container-menu').toggleClass('menu-open');
            $('body').toggleClass('hidden-overflow');
          });
    }
}

const menu = new Menu();
export default menu;
